export { default } from 'a11y-announcer/services/announcer';